export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_-Laravel-cb80e11fd0bfbca096209e5c8e3e6035.jpg";